import React from "react";

interface Props {
    label?: string;
    value: string;
    fullWidth?: boolean;
    placeholder?: string;
    onChange: (v: string) => void;
}

export function StringInput(props: Props) {
    const {fullWidth} = props;
    return (
        <input
            type="text"
            value={props.value}
            placeholder={props.placeholder}
            onChange={e => props.onChange(e.target.value)}
            style={{width: fullWidth ? '100%' : 100, height: 32, boxSizing: "border-box"}}
        />
    );
}
